const galleryTranslateEN = {
  section: {
    title: 'Galleries',
    createButton: 'New gallery',
    manageButton: 'Manage',
    emptyState: 'No galleries created yet',
    photosCount_one: '{{count}} photo',
    photosCount_other: '{{count}} photos',
    selectedCount: '{{selected}} of {{total}} selected',
    confirmedAt: 'Selection confirmed on {{date}}',
    status: {
      DRAFT: 'Draft',
      PUBLISHED: 'Published',
      ARCHIVED: 'Archived',
    },
  },
  createModal: {
    title: 'New gallery',
    fields: {
      name: 'Gallery name',
      event: 'Related event',
      noEvent: 'No event',
      selectionLimit: 'Selection limit',
      clientMessage: 'Message to the client',
    },
    errors: {
      nameRequired: 'Enter a name for the gallery',
      selectionLimitMin: 'The limit must be at least 1',
    },
    submit: 'Create gallery',
    cancel: 'Cancel',
  },
  manageModal: {
    title: 'Manage gallery',
    uploadButton: 'Add photos',
    uploadHint: 'JPEG, PNG or WebP up to 15MB',
    emptyPhotos: 'No photos yet',
    selectedSummary: 'The client selected {{selected}} of {{total}}',
    selectionPending: 'Waiting for the client selection',
    publicUrlLabel: 'Public link',
    copyLink: 'Copy link',
    linkCopied: 'Link copied',
    publish: 'Publish',
    archive: 'Archive',
    delete: 'Delete',
    removePhoto: 'Remove photo',
    clearFinished: 'Clear finished',
    queue: {
      uploading: 'Uploading',
      success: 'Done',
      error: 'Failed',
    },
    uploadErrors: {
      tooLarge: 'File is too large (max 15MB)',
      invalidType: 'Unsupported file type',
      invalidContent: 'File content does not match its type',
      processingFailed: 'Could not process the image',
      uploadFailed: 'Upload failed',
    },
    publishConfirm: {
      title: 'Publish gallery',
      text: 'Once published, the client can access the link and start selecting photos.',
      confirm: 'Publish',
      cancel: 'Cancel',
    },
    archiveConfirm: {
      title: 'Archive gallery',
      text: 'Archiving hides the gallery from the client. You can review it later.',
      confirm: 'Archive',
      cancel: 'Cancel',
    },
    deleteConfirm: {
      title: 'Delete gallery',
      text: 'This will permanently remove the gallery and its photos.',
      confirm: 'Delete',
      cancel: 'Cancel',
    },
  },
  public: {
    loading: 'Loading gallery...',
    notFoundTitle: 'Gallery not found',
    notFoundText:
      'This link may be invalid or the gallery is no longer available.',
    selectionCounter: '{{selected}} of {{limit}} selected',
    selectionCounterNoLimit: '{{selected}} selected',
    confirmButton: 'Confirm selection',
    confirmedBadge: 'Selection confirmed',
    confirmedAt: 'Confirmed on {{date}}',
    stillEditable:
      'You can still adjust your selection while the gallery is open.',
    saving: 'Saving...',
    saved: 'Changes saved',
    limitReached: 'You reached the selection limit',
    extrasInfo:
      'You reached the package limit — the next photos count as extras',
    selectPhoto: 'Select photo',
    deselectPhoto: 'Deselect photo',
    openPhoto: 'Open photo',
    closeLightbox: 'Close',
    prevPhoto: 'Previous photo',
    nextPhoto: 'Next photo',
    confirmModal: {
      title: 'Confirm selection',
      text: 'After confirming, the photographer will be notified. You can still adjust your selection while the gallery is open.',
      textExtras_one:
        'Your selection includes {{count}} extra photo beyond the package; it may be charged separately.',
      textExtras_other:
        'Your selection includes {{count}} extra photos beyond the package; they may be charged separately.',
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    toasts: {
      confirmed: 'Selection confirmed',
      confirmError: 'Could not confirm the selection',
      saveError: 'Could not save your selection',
    },
  },
  extrasCount_one: '{{count}} extra',
  extrasCount_other: '{{count}} extras',
  toasts: {
    created: 'Gallery created',
    createError: 'Could not create the gallery',
    published: 'Gallery published',
    publishError: 'Could not publish the gallery',
    archived: 'Gallery archived',
    archiveError: 'Could not archive the gallery',
    removed: 'Gallery deleted',
    removeError: 'Could not delete the gallery',
    photoRemoved: 'Photo removed',
    photoRemoveError: 'Could not remove the photo',
  },
};

export type GalleryTranslate = typeof galleryTranslateEN;

export default galleryTranslateEN;
